<template>
  <div class="a">
    <top></top>
    <navs></navs>
    <div class="content">
      <div class="time">
        <div class="cont">
          <div class="cont_a">
            <div class="bule"></div>
            <div class="p">日常证道</div>
          </div>
          <div class="cont_b">
            <div v-for="(item,index) in list" :key="index" class="cont_zd" @click="yzlh(item.id)">
              <div class="image">
                <img :src="item.placard" alt="" height="158px" width="158px">
              </div>
              <div class="cont_title">
                <h4>专辑名称：{{ item.name }}</h4>
                <h4>视频数量：{{ item.totalSize }}</h4>
                <div class="cont_text"><h4>专题简介：</h4><span style=" color: #333333;
 font-size: .15rem;">{{ item.briefInfo }}</span></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div
      style=" width: 100%; background: #fff; height: 60px; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
      <el-pagination :current-page="currentPage" :page-size="100" :page-sizes="[10, 20, 40, 60]" :total="total"
                     layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <bottom></bottom>
  </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import {preach} from "../api/index"
import axios from "axios";

export default {
  components: {
    top,
    bottom,
    navs
  },
  data() {
    return {
      list: [],
      total: 0, // 总数量
      pageNo: 1, // 当前页数
      pageSize: 10, // 当前显示数量
      currentPage: 1,
    }
  },
  created() {
    preach(this.pageNo, this.pageSize).then(res => {
      console.log(res)
      this.list = res.data.data.records
      this.total = res.data.data.total
    })
  },
  methods: {
    /**
     * 页码改变触发后
     * **/
    handleCurrentChange(val) {
      console.log(val, '页码改变触发后')
      this.pageNo = val
      preach(this.pageSize, this.pageNo).then(res => {
        console.log(res)
        this.list = res.data.data.records
        this.total = res.data.data.total
      })
    },
    /**
     * 每条多少页改变后
     * **/
    handleSizeChange(val) {
      console.log(val, '页数改变后')
      this.pageSize = val
      preach(this.pageSize, this.pageNo).then(res => {
        console.log(res)
        this.list = res.data.data.records
        this.total = res.data.data.total
      })

    },
    yzlh(item) {
      this.$router.push({path: "/yzlh", query: {id: item}})
    }
  }
}
</script>
<style scoped>
.a {
  width: 100%;
  /* height: 100vh; */
  margin: 0;
  padding: 0;
  background-color: #F7F7F7;
}

.content {
  width: 100%;
  /* height: 480px; */
  /* height: 1330px; */
  background-image: url(../image/back.png);
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.time {
  width: 70%;
  margin: 0 auto;
  /* height: 1330px; */
  /* background-color: #F7F7F7; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bule {
  width: 5px;
  height: 16px;
  background: #1463FF;
}

.p {
  margin-left: 5px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #333333;
  line-height: 17px;
  font-style: normal;
}

.cont {
  width: 100%;
  margin: 0 auto;
}

.cont_b {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.cont_zd {
  width: 48%;
  height: 190px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;

  margin-bottom: 20px;
}

.cont_zd:hover {
  width: 48%;
  height: 190px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  color: #1463FF;
  margin-bottom: 20px;
}

.image {
  width: 190px;
  height: 190px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cont_a {
  height: 74px;
  display: flex;
  align-items: center;
}

.cont_title {
  width: 60%;
  height: 158px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.cont_text {
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;

}
</style>



// WEBPACK FOOTER //
// src/views/zdzt.vue